/*
 * Tela de criar conta.
 *
 * A folha `formStyles` que ficava aqui (quase 40 linhas de `!important` contra
 * `.MuiInputBase-root`, `.MuiOutlinedInput-notchedOutline`, `.MuiButton-root`
 * etc, injetada via `<style>` inline) foi REMOVIDA junto com o MUI: ela era
 * fragil de um jeito especifico - uma renomeacao de classe interna do MUI numa
 * subida de versao devolvia a tela ao visual padrao sem nenhum erro de build.
 * O estilo agora mora no proprio RegisterForm e em CamposAuth, em Tailwind.
 *
 * O `AuthLayout` (ilustracao, selos, fundo) nao foi tocado.
 */
import NextLink from 'next/link';
import GuestGuard from '../../guards/GuestGuard';
import Page from '../../components/Page';
import { PATH_AUTH } from '../../routes/paths';
import { RegisterForm } from '../../sections/auth/register';
import AuthLayout from '../../sections/auth/AuthLayout';

const headerContent = (
  <div style={{ textAlign: 'center', marginBottom: 24 }}>
    <h1 style={{ margin: 0, fontSize: 24, fontWeight: 800, color: '#14213D', letterSpacing: '-0.4px' }}>Criar conta</h1>
    <p style={{ margin: '8px 0 0', fontSize: 13.5, color: '#66768F', lineHeight: 1.55 }}>
      Solicite acesso ao sistema MDM corporativo GPShub
    </p>
  </div>
);

const footer = (
  <>
    <div style={{ marginTop: 16, textAlign: 'center' }}>
      <span style={{ fontSize: 13, color: '#66768F' }}>Ja tem conta? </span>
      <NextLink href={PATH_AUTH.login} className="text-[12.5px] font-semibold text-[#1E63D5] hover:underline">
        Fazer login
      </NextLink>
    </div>
  </>
);

export default function Register() {
  return (
    <GuestGuard>
      <Page title="Criar conta - GPShub">
        <AuthLayout headerContent={headerContent} footer={footer} maxFormWidth={510}>
          <RegisterForm />
        </AuthLayout>
      </Page>
    </GuestGuard>
  );
}
